import axios from "axios";
import { API_URL, PELIAS_API_URL } from "../components/data/constants";
import { store } from "../";
import { logout, setUserLoaded } from "../store/actions/auth";
import { enqueueSnackbar } from "../store/actions/snackbars";
import { setCookie, getCookie, eraseCookie } from "../utils/cookies";
const API = axios.create({
  baseURL: API_URL
});

// TO2DO: dont like this part, maybe we do full rewrite

API.interceptors.request.use(request => {
  return request;
});

let snackbarShown = false;

API.interceptors.response.use(
  response => {
    return response;
  },
  async function (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      if (getCookie("refreshToken")) {
        const refreshToken = getCookie("refreshToken");
        try {
          const res = await axios.post(`${API_URL}/v1/token/refresh`, {
            token: refreshToken
          });

          setCookie("accessToken", `Bearer ${res.data.accessToken}`, 365);
          setCookie("refreshToken", res.data.refreshToken || "", 365);

          res.data.expiresAt && setCookie("expiresAt", res.data.expiresAt, 365);

          // Update axios instance Authorization
          API.defaults.headers.common["Authorization"] =
            getCookie("accessToken");

          console.dir(error);
          let data = error.config.data;
          data = data ? JSON.parse(data) : data;

          let response = await API[error.config.method](error.config.url, data);
          return Promise.resolve(response);
        } catch (e) {
          console.log("%c ERRORRR!!", "color: red;");
          console.dir(e);
          if (
            error.response &&
            (error.response.status === 401 ||
              (error.response.data &&
                error.response.data.message === "Refresh token not found."))
          ) {
            if (!snackbarShown) {
              eraseCookie("accessToken");
              eraseCookie("expiresAt");
              eraseCookie("refreshToken");

              store.dispatch(logout());
              store.dispatch(setUserLoaded(true));
              store.dispatch(
                enqueueSnackbar({
                  message:
                    "You've been logged out automatically, please login with your credentials"
                })
              );
              snackbarShown = true;
            }
          }
          return Promise.reject(error.response);
        }
      } else {
        if (!snackbarShown) {
          eraseCookie("accessToken");
          eraseCookie("expiresAt");
          eraseCookie("refreshToken");

          store.dispatch(logout());
          store.dispatch(setUserLoaded(true));
          store.dispatch(
            enqueueSnackbar({
              message:
                "You've been logged out automatically, please login with your credentials"
            })
          );
          snackbarShown = true;
        }
        return Promise.reject(error.response);
      }
    } else {
      // Do something with response error
      if (axios.isCancel(error)) {
        return Promise.reject(error);
      } else {
        return Promise.reject(error.response);
      }
    }
  }
);

export const API_NO_TOKEN = axios.create({ baseURL: API_URL, headers: {} });

export const PELIAS_API = axios.create({
  baseURL: PELIAS_API_URL,
  headers: {}
});

// Use interceptor for getting only response data instead of full response
PELIAS_API.interceptors.response.use(response => response.data);

API.defaults.headers.common["Authorization"] = getCookie("accessToken");
export default API;
